<template>
  <div class="honor">
    <div class="honor-head">
      <div class="honor-head-li" :class="showType === 4 ? 'honor-head-li-active' : ''" @click="changeList(4)">资质证书</div>
      <div class="honor-head-li" :class="showType === 5 ? 'honor-head-li-active' : ''" @click="changeList(5)">专利证书</div>
      <div class="honor-head-li" :class="showType === 6 ? 'honor-head-li-active' : ''" @click="changeList(6)">软件著作权</div>
    </div>
    <div class="honor-list">
      <div class="honor-list-li" v-for="item in picList" :key="item.id">
        <div class="honor-list-li-img" >
          <div class="honerImgBox">
            <el-image :src="`/boot${item.picture}`" :preview-src-list="previewList"></el-image>
          </div>
        </div>
        <div class="honor-list-li-title">{{ item.name }}</div>
      </div>
    </div>
    <div class="honor-page" v-show="pageInfo.total > 0">
      <div class="honor-page-btn" :class="pageInfo.pageNum === 1 ? 'no-click-btn' : ''" @click="changePage(1)"><i class="el-icon-arrow-left"></i>上一页</div>
      <div class="honor-page-num">
        <span v-for="ite in pageInfo.allPage" :class="pageInfo.pageNum === ite ? 'honor-page-num-active' : ''" @click="clickPage(ite)">{{ ite }}</span>
      </div>
      <div class="honor-page-btn" :class="pageInfo.pageNum === pageInfo.allPage ? 'no-click-btn' : ''" @click="changePage(2)">下一页<i class="el-icon-arrow-right"></i></div>
    </div>
  </div>
</template>

<script>
import {imgPageList} from "@/utils/http";

export default {
  name: "honor",
  data() {
    return {
      showType: 4,    // 4 资质证书   5 专利证书   6 软件著作权
      picList: [],
      previewList: [],
      pageInfo: {
        pageNum: 1,
        pageSize: 8,
        total: 0,
        allPage: 0,
      },
    };
  },
  created() {
    this.getPictureList()
  },
  methods: {
    async getPictureList() {
      // imgPageList(type, pageNum, pageSize)
      const res = await imgPageList(this.showType, this.pageInfo.pageNum, this.pageInfo.pageSize);
      this.picList = res.rows
      this.pageInfo.total = res.total
      this.pageInfo.allPage = Math.ceil(this.pageInfo.total / this.pageInfo.pageSize)
      // 保存图片预览URL
      this.previewList = res.rows.map((item) => {
        return `/boot${item.picture}`
      })
    },
    // 切换类型tab
    changeList(i) {
      this.showType = i
      this.pageInfo.pageNum = 1
      this.getPictureList()
    },
    // 分页切换
    changePage(i) {
      // 总页数
      if (this.pageInfo.allPage <= 1) {
        return
      }
      // 上一页
      if (i == 1) {
        if (this.pageInfo.pageNum > 1) {
          this.pageInfo.pageNum -= 1
          this.getPictureList()
        }
      }
      // 下一页
      if (i == 2) {
        if (this.pageInfo.pageNum < this.pageInfo.allPage) {
          this.pageInfo.pageNum += 1
          this.getPictureList()
        }
      }
    },
    clickPage(i) {
      this.pageInfo.pageNum = i
      this.getPictureList()
    }
  }
};
</script>

<style lang="scss" scoped>
.honor {
  &-head {
    width: max-content;
    margin: 15px auto 30px;
    height: 35px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #E4E4E4;
    &-li {
      width: 112px;
      font-weight: 400;
      font-size: 16px;
      line-height: 18px;
      color: #898989;
      text-align: center;
      cursor: pointer;
    }
    &-li:hover {
      opacity: .75;
    }
    &-li-active {
      position: relative;
      color: #222222;
    }
    &-li-active::before {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: #222222;
      position: absolute;
      left: 0;
      right: 0;
      bottom: -1px;
    }
    &-li-active::after {
      content: '';
      display: block;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid #222222;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
    }
  }
  &-list {
    height:800px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    align-content: flex-start;
    &-li {
      margin-bottom: 20px;
      margin-right: 20px;
      width: 285px;
      height: 385px;
      background: #FFFFFF;
      box-shadow: 0px 6px 30px 1px rgba(0, 0, 0, 0.06);
      &-img {
        padding: 40px 45px 5px;
        height: 265px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .honerImgBox {
          width: 100%;
          border: 5px solid #565656;
          padding: 4px;
        }
      }

      &-title {
        margin-top: 20px;
        font-weight: 400;
        font-size: 15px;
        color: #222222;
        text-align: center;
      }
    }
    &-li:nth-child(4n) {
      margin-right: 0;
    }
  }
  &-page {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    align-items: center;

    .honor-page-btn:hover {
      opacity: .9;
      color: #1277E4;
    }
    .honor-page-btn {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      cursor: pointer;
    }
    .honor-page-num {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      cursor: pointer;
      margin: 0 8px;
      span {
        margin: 0 8px;
      }
      &-active {
        cursor: default;
        color: #1277E4;
      }
    }
    .no-click-btn {
      cursor: not-allowed;
      opacity: .75;
    }

    .honor-page-num:hover {
      color: #1277E4;
      opacity: .75;
    }
    .honor-page-num-active:hover {
      color: #1277E4;
      opacity: 1;
    }
    .no-click-btn:hover {
      cursor: not-allowed;
      color: #666666;
      opacity: .75;
    }
  }
}
</style>
